<template>
    <div>
        <top :id="'brand'"></top>
        <banner :url="url"></banner>
        <div class="container">
            <breadcrumb :url="url"></breadcrumb>
            <!-- 查找 -->
            <div class="search">
                <div class="letter flex ali-cen" style="margin-bottom: 20px;">
                    <div
                        class="flex jus-cen ali-cen f20 grey"
                        style="width: 129px;height: 56px;background-color: #fff;margin-right: 20px;"
                    >
                        按字母查找
                    </div>
                    <div>
                        <span class="f20 f2"  ref="a" style="display:inline-block;width:30px;text-align:center;" v-for="i in zimu" @click="zimuBnt(i)" :key="i">{{i}}</span>
                    </div>
                </div>
            </div>
            <!-- 查找列表 -->
            <div class="srarch_list_wp">
                <div class="srarch_list" v-for="item in newlists[0]" :key="item.id">
                    <!-- <span>{{item.brand_text}}</span> -->
                    <img :src="item.image" @click="getLIst(item.id)" alt="" />
                    <span class="brand_hove" style="text-align:center; display: block;">{{item.brand_text}}</span>
                </div>

            </div>

            <!-- 内容 -->
            <div class="flex flex-wrap" style="margin-top:50px">
                <div class="seckill3 shdow1" v-for="item in shoopingLists" :key="item.id">
                    <img :src="item.image" alt="" />
                    <div class="seckill-con">
                        <div class="f24" style="margin-bottom: 20px;">
                            {{item.title}}
                        </div>
                        <div class="F-flex">
                            <div>
                                <div class="f20 orange">¥{{item.price}}</div>
                                <div class="f12 grey text-decoration">
                                    ¥{{item.original_price}}
                                </div>
                            </div>
                            <div class="btn" @click="brandShoppingBnt(item.id)">立即购买</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import top from "../../components/top.vue";
import breadcrumb from "../../components/breadcrumb.vue";
import bottom from "../../components/bottom.vue";
import banner from "../../components/banner.vue";
import tit from "../../components/title.vue";
import goods from "../../components/goods.vue";

import {brandIndex,lists} from  "@/api/index.js"

export default {
    data() {
        return {
            url: [{ name: "品牌筛选", url: "/brand" }],
            zimu:[],
            brandList:[],
            newlists:[],
            shoopingLists:[]

        };
    },
    beforeCreate() {
        document
            .querySelector("body")
            .setAttribute("style", "background:#f5f5f5");
    },
    created() {
    this.getBrandList()

    },
    methods:{
    getBrandList(){
    brandIndex({}).then(res=>{

        this.brandList.push(res.data.lists)
        var reg = /[A-Z]$/
        console.log(this.brandList);

        if(reg.test(Object.keys(res.data.lists))){
           this.zimu = Object.keys(res.data.lists)
        }else{
           this.zimu = ['A','B','C','D','E','F','G','H','I','J','K','l','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
           this.zimuBnt('A')
        }

    })
    },
    zimuBnt(i){
    var newList = []
    this.newlists = newList
    console.log(this.newlists);
    this.brandList.forEach(item=>{
        console.log(i);
        if(Object.keys(item).indexOf(i) != -1){
        newList.push(item[i]);
        console.log(newList);
        }

    })
    return newList
    },
    getLIst(id){

        lists({brand_id:id}).then(res=>{
            if(res.code !==1){
                return
            }
        this.shoopingLists = res.data.data
        })
    },
      //点击立即购买
    brandShoppingBnt(id){
        this.$router.push({name:'info',query: {id:id}})
    }
    },
    components: {
        top,
        breadcrumb,
        bottom,
        banner,
        tit,
        goods
    }
};
</script>
<style scoped lang="less">
.shdow1{
  transition: all .2s linear;
}
.shdow1:hover{
transform: translateX(0) translateY(-5px);
box-shadow: 0px 9px 31px 0px rgba(0, 0, 0, 0.1);
}
.brand_hove:hover{
color: #0070BE;
display: block;
}
.f2:hover{
 background-color: #0070BE;
 color: #fff;
 display: inline-block;
}
.seckill1 {
    width: 792px;
    height: 312px;
    position: relative;
    margin-bottom: 20px;
    img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
    }
}
.seckill2 {
    width: 383px;
    height: 312px;
    position: relative;
    margin-bottom: 20px;
    img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
    }
}
.seckill3 {
    width: 383px;
    background-color: #fff;
    border-radius: 8px;
    margin-bottom: 20px;
    margin-right: 25px;
    cursor: pointer;
    &:nth-child(3n + 3) {
        margin-right: 0;
    }
    img {
        width: 383px;
        height: 223px;
        border-radius: 8px 8px 0 0;
    }
    .seckill-con {
        padding: 30px;
    }
}
.btn {
    width: 111px;
    height: 34px;
    background: #ff6701;
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
}
.btn-pos {
    position: absolute;
    bottom: -60px;
    right: 50px;
}
.seckill-box {
    padding: 30px 20px;
    width: 242px;
    height: 191px;
    background: #ffffff;
    border-radius: 8px;
    opacity: 0.84;
    position: absolute;
    top: 10px;
    right: 30px;
    z-index: 10;
    .seckill-money {
        position: relative;
    }
}
.srarch_list_wp {
    display: flex;
    flex-wrap: wrap;
    .srarch_list {
        width: 172px;
        height: 127px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #f0f0f0;
        margin: 0 28px 22px 0;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;

        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/brand.vue